import React from "react"
import {Wrapper} from "./component"
import connect from "./connect"
import Modal from "../../../../components/Modal"

export type ModalProps = {
    open: boolean
    closeText: string
    handleClose: () => void
    children: JSX.Element
    hideBackdrop: boolean | null
    desktopHeight: number
    isNoResults: boolean | null
}

const EnrichModal = ({
    open,
    handleClose,
    children,
    closeText,
    hideBackdrop,
    desktopHeight,
    isNoResults,
}: ModalProps) => {
    return isNoResults ? null : (
        <Wrapper desktopHeight={desktopHeight}>
            <Modal open={open} handleClose={handleClose} hideBackdrop={hideBackdrop === null ? true : hideBackdrop}>
                <>
                    {children}
                    {/* eslint-disable-next-line jsx-a11y/no-noninteractive-element-to-interactive-role */}
                    <div tabIndex={0} role="button" onFocus={handleClose} aria-label={closeText} />
                </>
            </Modal>
        </Wrapper>
    )
}

export default connect(EnrichModal)
